import { useQuery } from "@apollo/client";
import { ProfileSkeleton } from "@/components/Skeleton";
import { GET_ACTIVITY_TYPE } from "@/pages/activities/activity-types/queries";
import ObjectHeading from "@/components/ObjectHeading";
import { renderCreditRate } from "@/pages/activities/activity-types/_utils";

export interface MobileActivityTypeOverviewProps {
  activityTypeId: string;
}

export default function MobileActivityTypeOverview({ activityTypeId }: MobileActivityTypeOverviewProps) {
  const { data, loading, error } = useQuery(GET_ACTIVITY_TYPE, {
    variables: { id: activityTypeId }
  });

  if (loading) return <ProfileSkeleton />;
  if (error) return <div>Error loading activity type details</div>;
  if (!data?.activityType) return <div>Activity type not found</div>;

  const { activityType } = data;
  const metaData = [
    ...(activityType?.config
      ? [
          {
            text: renderCreditRate(activityType.config.creditRates),
            label: "PDR Credit Rate"
          }
        ]
      : [])
  ];

  return (
    <div
      className="bg-sys-brand-surface pb-4 border-b border-sys-brand-outline-variant"
      data-testid="mobile-activity-type-overview"
    >
      <ObjectHeading title={activityType.title} iconName="assignment" variant="landing-page" metaData={metaData} />
    </div>
  );
}
